import { useRef } from "react"
import { Alert, Stack, Typography } from "@mui/material"
import { DialogBox } from "lib/@components/dialogBox"
import { Bound } from "lib/@components/binding/Bound"
import { BoundDatePicker } from "lib/@components/datePicker"
import { formatLegacyPublishedDate } from "authoring/lib/format-legacy-published-date.mjs"
import { ApprovedSchedulesList } from "./approved-schedules-list"

export function SetPublishedDateDialog({ approvedSchedules = [] }) {
    const target = useRef({ publishDate: new Date() }).current

    return (
        <DialogBox
            title={<Typography variant="h5">Set published date</Typography>}
            value={true}
            okCaption="Set published date"
            beforeOk={resolvePublishDate}
            data-cy="set-published-date-dialog"
        >
            <Bound target={target}>
                <Stack spacing={2}>
                    <Alert severity="warning" data-cy="set-published-date-warning">
                        Use this once the schedules have been published in Legacy.
                    </Alert>
                    <Typography variant="body2" color="text.secondary">
                        Sets the published date in Legacy and on the approved drafts in this work package.
                    </Typography>
                    <ApprovedSchedulesList schedules={approvedSchedules} data-cy="set-published-date-approved-list" />
                    <BoundDatePicker
                        field="publishDate"
                        label="Published date"
                        textFieldProps={{ "data-cy": "set-published-date-picker" }}
                    />
                </Stack>
            </Bound>
        </DialogBox>
    )

    function resolvePublishDate() {
        return target.publishDate ? formatLegacyPublishedDate(target.publishDate) : null
    }
}
